// extracted by mini-css-extract-plugin
export default {"autopromo-picture":"autopromoQ83eBz","autopromo-picture__source":"autopromodQsi8A","autopromo-img":"autopromoQ7bezs"};